// extracted by mini-css-extract-plugin
module.exports = {"wishlistToggle":"WishlistToggle_wishlistToggle__SXbIi","wishlistToggleLarge":"WishlistToggle_wishlistToggleLarge__WqXyv"};